module.exports = __webpack_public_path__ + "static/media/parking.425d5ecd.svg";